import { render, staticRenderFns } from "./NuestraRedView.vue?vue&type=template&id=3e34fd18"
import script from "./NuestraRedView.vue?vue&type=script&lang=ts"
export * from "./NuestraRedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports